module.exports = __webpack_public_path__ + "img/app_equity.09386cbf.png";